import {ApiService} from "./api.service";

export class HouseholdService extends ApiService {
  constructor(organizationId) {
    super();
    this.organizationId = organizationId;
    this.endpoint = `/organizations/${organizationId}/households`;
    this.per = 10;
  }
}
